import * as React from 'react';

import '../styles/components/404.scss';
import Helmet from 'react-helmet';
import { generatePath } from 'react-router-dom';
import { SRP_BASE } from '../urls';

const NotFound: React.SFC = (props) => {
    return (
        <div className='NotFound'>
            <Helmet>
                <title>Page Not Found - Wedding Spot</title>
                <body className='body-not-found' />
            </Helmet>
            <div className='NotFound--content'>
                <div className='NotFound--content-border'>
                    <div className='NotFound--content-inner'>
                        <h1 className='NotFound--header'>Not Found</h1>
                        <br />
                        <p className='NotFound--message'>
                            The page you were looking for was not found. If you believe this message was in error please&nbsp;
                            <a href='mailto:support@wedding-spot.com'>let us know</a>.
                        </p>
                        <br />
                        <a href={generatePath(SRP_BASE)} className='NotFound--cta nx-button nx-button--primary'>
                            Find a venue
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
